var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('section',[_c('h2',{staticClass:"text-center font-weight-regular mb-5 mb-sm-10"},[_vm._v("Правила оплаты и доставки")]),_c('div',{staticClass:"payment-text",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }